const notImplemented = () => {
    throw new Error('not implemented');
};
// FIXME: This is a bit backwards... it should actually be called ErrorReporter (and vice versa).
export class SentryReporter {
    constructor() {
        this._disposed = false;
        this.breadcrumb = notImplemented;
    }
    dispose() {
        this._disposed = true;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VudHJ5UmVwb3J0ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY2xpZW50L1NlbnRyeVJlcG9ydGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFBLE1BQU0sY0FBYyxHQUFHLEdBQUcsRUFBRTtJQUMxQixNQUFNLElBQUksS0FBSyxDQUFDLGlCQUFpQixDQUFDLENBQUM7QUFDckMsQ0FBQyxDQUFDO0FBaUJGLGlHQUFpRztBQUNqRyxNQUFNLE9BQWdCLGNBQWM7SUFBcEM7UUFDRSxjQUFTLEdBQUcsS0FBSyxDQUFDO1FBQ2xCLGVBQVUsR0FBaUMsY0FBYyxDQUFDO0lBc0I1RCxDQUFDO0lBcEJDLE9BQU87UUFDTCxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQztJQUN4QixDQUFDO0NBa0JGIn0=